# Hygiene für glückliche Haustiere: Pflege, Zahnhygiene & Fellgesundheit

Saubere Routinen halten Tiere komfortabel, reduzieren Hautprobleme und helfen, Veränderungen früh zu erkennen. Dieser Leitfaden unterstützt einfache Gewohnheiten rund um Pflege, Zähne, Fell und ein sauberes Zuhause.

<ArticleImage
  src="/images/guide/hygiene-grooming.jpg"
  alt="Saubere Hände und Pflegetools"
  caption="Saubere Hände und Tools machen die Pflege sicherer."
/>

---

<Section emoji="🧴" title="Pflege passend zum Fell">

<Tip label="Bürstrhythmus" text="Kurzhaar reicht oft wöchentlich, Langhaar und Doppelfell benötigen mehrere Bürstungen pro Woche." />
<Tip label="Badeintervall" text="Die meisten Tiere kommen mit monatlichem oder bedarfsweisem Baden gut zurecht." />
<Tip label="Pfoten, Ohren, Krallen" text="Krallen regelmäßig kürzen, Pfoten nach Spaziergängen säubern, Ohren sauber und trocken halten." />

</Section>

<ArticleImage
  src="/images/guide/hygiene-paws.jpg"
  alt="Pfotenpflege nach dem Spaziergang"
  caption="Pfoten nach Matsch abspülen und auf Dornen prüfen."
/>

<Section emoji="🦷" title="Zahnpflege, die bleibt">

<Tip label="Zähneputzen" text="Tierzahnpasta und eine weiche Bürste ein paar Mal pro Woche helfen enorm." />
<Tip label="Kauartikel" text="Dental‑Snacks und strukturierte Spielzeuge reduzieren Zahnbelag." />
<Tip label="Tierarzt" text="Mundgeruch, Speichelfluss oder rote Stellen sind Signale für einen Check." />

</Section>

<ArticleImage
  src="/images/guide/hygiene-bowls.jpg"
  alt="Saubere Näpfe"
  caption="Näpfe täglich reinigen, um Bakterien und Gerüche zu reduzieren."
/>

<Section emoji="🐾" title="Haut, Ohren & Augen">

<Tip label="Haut" text="Achte auf Rötungen, Schuppen, Krusten oder dauerhaftes Kratzen." />
<Tip label="Ohren" text="Milder Reiniger und Wattepad reichen – keine Wattestäbchen tief einführen." />
<Tip label="Augen" text="Sekret mit einem feuchten Tuch abwischen und übermäßiges Tränen beobachten." />

</Section>

<ArticleImage
  src="/images/guide/hygiene-horse.jpg"
  alt="Sonnige Szene"
  caption="Helle Nasen und Ohren profitieren von tiergeeignetem Sonnenschutz."
/>

<Section emoji="🏠" title="Hygiene zu Hause">

<Tip label="Bettwäsche" text="Schlafplätze wöchentlich waschen und Liegebereiche absaugen." />
<Tip label="Klo & Abfall" text="Katzentoiletten täglich säubern, Kot unterwegs zeitnah entfernen." />
<Tip label="Zubehör" text="Bürsten, Halsbänder und Geschirre reinigen, um Reizungen zu vermeiden." />

</Section>

<Disclaimer title="⚠️ Hinweis">
Dieser Leitfaden ist informativ und ersetzt keine tierärztliche Beratung. Bei anhaltenden Haut‑ oder Ohrenproblemen bitte den Tierarzt kontaktieren.
</Disclaimer>
